import { createSlice } from '@reduxjs/toolkit';

import {
  carregarPreferenciasUi,
  concluirChecklistSetores,
  dispensarChecklistConfiguracao,
} from './actions';

export interface PreferenciasUiState {
  checklistDispensado: boolean | null;
  checklistSetoresConcluido: boolean;
}

const initialState: PreferenciasUiState = {
  checklistDispensado: null,
  checklistSetoresConcluido: false,
};

const preferenciasUiSlice = createSlice({
  name: 'preferenciasUi',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(carregarPreferenciasUi.fulfilled, (state, action) => {
        state.checklistDispensado = Boolean(action.payload.checklistConfiguracaoDispensado);
        state.checklistSetoresConcluido = Boolean(action.payload.checklistSetoresConcluido);
      })
      .addCase(carregarPreferenciasUi.rejected, (state) => {
        state.checklistDispensado = true;
      })
      .addCase(dispensarChecklistConfiguracao.pending, (state) => {
        state.checklistDispensado = true;
      })
      .addCase(dispensarChecklistConfiguracao.rejected, (state) => {
        state.checklistDispensado = false;
      })
      .addCase(concluirChecklistSetores.pending, (state) => {
        state.checklistSetoresConcluido = true;
      })
      .addCase(concluirChecklistSetores.rejected, (state) => {
        state.checklistSetoresConcluido = false;
      });
  },
});

export default preferenciasUiSlice.reducer;
